/* tslint:disable */
/* eslint-disable */
/**
 * API SPECS
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { Baby } from './Baby';
import {
    BabyFromJSON,
    BabyFromJSONTyped,
    BabyToJSON,
} from './Baby';
import type { PaginationInfo } from './PaginationInfo';
import {
    PaginationInfoFromJSON,
    PaginationInfoFromJSONTyped,
    PaginationInfoToJSON,
} from './PaginationInfo';

/**
 * 
 * @export
 * @interface BabyPagination
 */
export interface BabyPagination {
    /**
     * 
     * @type {Array<Baby>}
     * @memberof BabyPagination
     */
    data?: Array<Baby>;
    /**
     * 
     * @type {PaginationInfo}
     * @memberof BabyPagination
     */
    meta?: PaginationInfo;
}

/**
 * Check if a given object implements the BabyPagination interface.
 */
export function instanceOfBabyPagination(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function BabyPaginationFromJSON(json: any): BabyPagination {
    return BabyPaginationFromJSONTyped(json, false);
}

export function BabyPaginationFromJSONTyped(json: any, ignoreDiscriminator: boolean): BabyPagination {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'data': !exists(json, 'data') ? undefined : ((json['data'] as Array<any>).map(BabyFromJSON)),
        'meta': !exists(json, 'meta') ? undefined : PaginationInfoFromJSON(json['meta']),
    };
}

export function BabyPaginationToJSON(value?: BabyPagination | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'data': value.data === undefined ? undefined : ((value.data as Array<any>).map(BabyToJSON)),
        'meta': PaginationInfoToJSON(value.meta),
    };
}

